var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.921
    },
    fill: "#fe3398",
    d: "M 42.5,-0.5 C 113.833,-0.5 185.167,-0.5 256.5,-0.5C 275.407,1.22737 288.574,10.894 296,28.5C 296.667,31.1667 297.333,33.8333 298,36.5C 298.667,111.833 298.667,187.167 298,262.5C 294.701,278.124 285.867,289.29 271.5,296C 266.455,297.575 261.455,298.741 256.5,299.5C 185.167,299.5 113.833,299.5 42.5,299.5C 23.593,297.773 10.4263,288.106 3,270.5C 2.33333,267.833 1.66667,265.167 1,262.5C 0.333333,187.167 0.333333,111.833 1,36.5C 4.2992,20.8765 13.1325,9.7098 27.5,3C 32.5452,1.42533 37.5452,0.258665 42.5,-0.5 Z M 44.5,11.5 C 114.501,11.3333 184.501,11.5 254.5,12C 271.426,13.2636 281.926,22.097 286,38.5C 286.667,112.5 286.667,186.5 286,260.5C 281.788,277.373 270.955,286.206 253.5,287C 184.167,287.667 114.833,287.667 45.5,287C 28.0453,286.206 17.212,277.373 13,260.5C 12.3333,186.5 12.3333,112.5 13,38.5C 17.2396,22.0875 27.7396,13.0875 44.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.88
    },
    fill: "#fe3398",
    d: "M 101.5,63.5 C 108.327,62.8253 111.16,65.8253 110,72.5C 94.5567,89.612 78.2234,105.612 61,120.5C 54.4286,115.936 48.4286,110.602 43,104.5C 40.0843,96.4101 42.9176,93.2435 51.5,95C 54.5,98 57.5,101 60.5,104C 61.1667,104.667 61.8333,104.667 62.5,104C 75.3394,90.3276 88.3394,76.8276 101.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#fe3398",
    d: "M 137.5,67.5 C 177.501,67.3333 217.501,67.5 257.5,68C 262.285,71.26 262.619,74.9266 258.5,79C 217.833,79.6667 177.167,79.6667 136.5,79C 132.95,75.0429 133.283,71.2096 137.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#fe3398",
    d: "M 137.5,109.5 C 166.169,109.333 194.835,109.5 223.5,110C 227.487,113.713 227.487,117.38 223.5,121C 194.5,121.667 165.5,121.667 136.5,121C 132.972,117 133.305,113.166 137.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.882
    },
    fill: "#fe3398",
    d: "M 103.5,172.5 C 110.458,173.484 112.291,177.151 109,183.5C 94.1374,198.029 79.6374,212.862 65.5,228C 62.5,230 59.5,230 56.5,228C 52.0334,222.532 47.2,217.365 42,212.5C 40.8333,205.667 43.6667,202.833 50.5,204C 54,207.5 57.5,211 61,214.5C 74.5294,201.305 87.6961,187.805 100.5,174C 101.737,173.768 102.737,173.268 103.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#fe3398",
    d: "M 137.5,179.5 C 175.168,179.333 212.835,179.5 250.5,180C 252.815,181.296 253.815,183.296 253.5,186C 253.91,188.575 252.91,190.242 250.5,191C 212.833,191.667 175.167,191.667 137.5,191C 132.734,187.442 132.734,183.609 137.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.914
    },
    fill: "#fe3398",
    d: "M 137.5,221.5 C 166.169,221.333 194.835,221.5 223.5,222C 227.487,225.713 227.487,229.38 223.5,233C 194.833,233.667 166.167,233.667 137.5,233C 132.734,229.442 132.734,225.609 137.5,221.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPink);
export default __webpack_public_path__ + "static/media/Dashboard_pink.2814228235607d35566b753e0d6df869.svg";
export { ForwardRef as ReactComponent };